import ServiceWorkerInterfaceV1 from './ServiceWorkerInterfaceV1';
import { ServiceWorkerInterfaceV1Type } from '@clientos/types';
import { getServices } from '../../../infra/startup';
import { internalLogger } from '../clientOsLogger';

let serviceWorkerInterfaceV1: ServiceWorkerInterfaceV1;

export function getServiceWorkerInterfaceV1(): ServiceWorkerInterfaceV1Type {
  return serviceWorkerInterfaceV1.getInterface();
}

export default async function initializeServiceWorkerInterfaceV1(): Promise<ServiceWorkerInterfaceV1Type> {
  if (serviceWorkerInterfaceV1) return serviceWorkerInterfaceV1.getInterface();

  const { serviceWorkerService } = getServices();

  serviceWorkerInterfaceV1 = new ServiceWorkerInterfaceV1({
    serviceWorkerService
  });

  return serviceWorkerInterfaceV1.getInterface();
}

export function createNoopServiceWorkerInterface(): ServiceWorkerInterfaceV1Type {
  return {
    clearCache: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceWorkerInterface',
        methodName: 'clearCache()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    }
  };
}
